export default "__VITE_ASSET__Dr8$VFZt__"